import { format } from 'date-fns';
import { matchesCallStatusFilter } from './callStatus';

export const filterAICalls = (
  calls,
  { candidateSearch = '', dateFilter = '', statusFilter = 'all' } = {},
) => {
  const search = candidateSearch.trim().toLowerCase();

  return (calls ?? []).filter((call) => {
    const matchesCandidate = !search || [
      call.candidate?.full_name,
      call.candidate?.current_position,
    ].some((value) => value?.toLowerCase().includes(search));

    const matchesDate = !dateFilter
      || format(new Date(call.created_at), 'yyyy-MM-dd') === dateFilter;

    const matchesStatus = matchesCallStatusFilter(call.status, statusFilter);

    return matchesCandidate && matchesDate && matchesStatus;
  });
};
